import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class app_ds_find_accountService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { LookupCode?: string, Name?: string, TypeId?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, Name?: string, AccountsContactsLookup?: { ContactId?: number, Contact?: { AddressId?: number } }[] } }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      LookupCode?: string, Name?: string, TypeId?: number    }) {
      return false;
    }
}
